module.exports = __webpack_public_path__ + "static/img/p3.31f130c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/p3.png
// module id = gQwM
// module chunks = 0